"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlowDeleted = void 0;
var irt_1 = require("@playq/irt");
var octopus_common_1 = require("@playq/octopus-common");
var NotificationWithApp_1 = require("./NotificationWithApp");
var Class_1 = require("./Class");
var Notification_1 = require("./Notification");
var NotificationWithUser_1 = require("./NotificationWithUser");
var NotificationWithFlow_1 = require("./NotificationWithFlow");
var MutationNotificationContract_1 = require("./MutationNotificationContract");
var FlowDeleted = (function () {
    function FlowDeleted(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.userID = new octopus_common_1.UserID(data.userID);
        this.userName = typeof data.userName !== 'undefined' ? data.userName : undefined;
        this.class_ = Class_1.Class[data.class];
        this.atAsString = data.at;
        this.message = typeof data.message !== 'undefined' ? data.message : undefined;
        this.appID = data.appID;
        this.appName = typeof data.appName !== 'undefined' ? data.appName : undefined;
        this.flowID = data.flowID;
        this.flowName = data.flowName;
    }
    FlowDeleted.prototype.getPackageName = function () { return FlowDeleted.PackageName; };
    FlowDeleted.prototype.getClassName = function () { return FlowDeleted.ClassName; };
    FlowDeleted.prototype.getFullClassName = function () { return FlowDeleted.FullClassName; };
    Object.defineProperty(FlowDeleted.prototype, "userID", {
        get: function () {
            return this._userID;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field userID is not optional');
            }
            this._userID = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FlowDeleted.prototype, "userName", {
        get: function () {
            return this._userName;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                this._userName = undefined;
                return;
            }
            if (typeof value !== 'string') {
                throw new Error('Field userName expects type string, got ' + value);
            }
            this._userName = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FlowDeleted.prototype, "class_", {
        get: function () {
            return this._class;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field class_ is not optional');
            }
            this._class = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FlowDeleted.prototype, "at", {
        get: function () {
            return this._at;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field at is not optional');
            }
            if (!(value instanceof Date)) {
                throw new Error('Field at expects type Date, got ' + value);
            }
            this._at = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FlowDeleted.prototype, "atAsString", {
        get: function () {
            return irt_1.Formatter.writeZoneDateTime(this._at);
        },
        set: function (value) {
            if (typeof value !== 'string') {
                throw new Error('atAsString expects type string, got ' + value);
            }
            this._at = irt_1.Formatter.readZoneDateTime(value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FlowDeleted.prototype, "message", {
        get: function () {
            return this._message;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                this._message = undefined;
                return;
            }
            if (typeof value !== 'string') {
                throw new Error('Field message expects type string, got ' + value);
            }
            this._message = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FlowDeleted.prototype, "appID", {
        get: function () {
            return this._appID;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field appID is not optional');
            }
            if (typeof value !== 'number') {
                throw new Error('Field appID expects type number, got ' + value);
            }
            if (value % 1 !== 0) {
                throw new Error('Field appID is expected to be an integer, got ' + value);
            }
            this._appID = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FlowDeleted.prototype, "appName", {
        get: function () {
            return this._appName;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                this._appName = undefined;
                return;
            }
            if (typeof value !== 'string') {
                throw new Error('Field appName expects type string, got ' + value);
            }
            this._appName = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FlowDeleted.prototype, "flowID", {
        get: function () {
            return this._flowID;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field flowID is not optional');
            }
            if (typeof value !== 'number') {
                throw new Error('Field flowID expects type number, got ' + value);
            }
            if (value % 1 !== 0) {
                throw new Error('Field flowID is expected to be an integer, got ' + value);
            }
            this._flowID = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FlowDeleted.prototype, "flowName", {
        get: function () {
            return this._flowName;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field flowName is not optional');
            }
            if (typeof value !== 'string') {
                throw new Error('Field flowName expects type string, got ' + value);
            }
            this._flowName = value;
        },
        enumerable: false,
        configurable: true
    });
    FlowDeleted.prototype.toNotificationWithFlowSerialized = function () {
        return {
            userID: this.userID.serialize(),
            userName: typeof this.userName !== 'undefined' ? this.userName : undefined,
            class: Class_1.Class[this.class_],
            at: this.atAsString,
            message: typeof this.message !== 'undefined' ? this.message : undefined,
            appID: this.appID,
            appName: typeof this.appName !== 'undefined' ? this.appName : undefined,
            flowID: this.flowID,
            flowName: this.flowName
        };
    };
    FlowDeleted.prototype.toNotificationWithFlow = function () {
        return new NotificationWithFlow_1.NotificationWithFlowStruct(this.toNotificationWithFlowSerialized());
    };
    FlowDeleted.prototype.toNotificationWithAppSerialized = function () {
        return {
            class: Class_1.Class[this.class_],
            at: this.atAsString,
            message: typeof this.message !== 'undefined' ? this.message : undefined,
            appID: this.appID,
            appName: typeof this.appName !== 'undefined' ? this.appName : undefined
        };
    };
    FlowDeleted.prototype.toNotificationWithApp = function () {
        return new NotificationWithApp_1.NotificationWithAppStruct(this.toNotificationWithAppSerialized());
    };
    FlowDeleted.prototype.toNotificationSerialized = function () {
        return {
            class: Class_1.Class[this.class_],
            at: this.atAsString,
            message: typeof this.message !== 'undefined' ? this.message : undefined
        };
    };
    FlowDeleted.prototype.toNotification = function () {
        return new Notification_1.NotificationStruct(this.toNotificationSerialized());
    };
    FlowDeleted.prototype.toMutationNotificationContractSerialized = function () {
        return {
            class: Class_1.Class[this.class_],
            at: this.atAsString,
            message: typeof this.message !== 'undefined' ? this.message : undefined,
            userID: this.userID.serialize(),
            userName: typeof this.userName !== 'undefined' ? this.userName : undefined
        };
    };
    FlowDeleted.prototype.toMutationNotificationContract = function () {
        return new MutationNotificationContract_1.MutationNotificationContractStruct(this.toMutationNotificationContractSerialized());
    };
    FlowDeleted.prototype.toNotificationWithUserSerialized = function () {
        return {
            class: Class_1.Class[this.class_],
            at: this.atAsString,
            message: typeof this.message !== 'undefined' ? this.message : undefined,
            userID: this.userID.serialize(),
            userName: typeof this.userName !== 'undefined' ? this.userName : undefined
        };
    };
    FlowDeleted.prototype.toNotificationWithUser = function () {
        return new NotificationWithUser_1.NotificationWithUserStruct(this.toNotificationWithUserSerialized());
    };
    FlowDeleted.prototype.loadNotificationWithFlowSerialized = function (slice) {
        this.userID = new octopus_common_1.UserID(slice.userID);
        this.userName = typeof slice.userName !== 'undefined' ? slice.userName : undefined;
        this.class_ = Class_1.Class[slice.class];
        this.atAsString = slice.at;
        this.message = typeof slice.message !== 'undefined' ? slice.message : undefined;
        this.appID = slice.appID;
        this.appName = typeof slice.appName !== 'undefined' ? slice.appName : undefined;
        this.flowID = slice.flowID;
        this.flowName = slice.flowName;
    };
    FlowDeleted.prototype.loadNotificationWithFlow = function (slice) {
        this.loadNotificationWithFlowSerialized(slice.serialize());
    };
    FlowDeleted.prototype.loadNotificationWithAppSerialized = function (slice) {
        this.class_ = Class_1.Class[slice.class];
        this.atAsString = slice.at;
        this.message = typeof slice.message !== 'undefined' ? slice.message : undefined;
        this.appID = slice.appID;
        this.appName = typeof slice.appName !== 'undefined' ? slice.appName : undefined;
    };
    FlowDeleted.prototype.loadNotificationWithApp = function (slice) {
        this.loadNotificationWithAppSerialized(slice.serialize());
    };
    FlowDeleted.prototype.loadNotificationSerialized = function (slice) {
        this.class_ = Class_1.Class[slice.class];
        this.atAsString = slice.at;
        this.message = typeof slice.message !== 'undefined' ? slice.message : undefined;
    };
    FlowDeleted.prototype.loadNotification = function (slice) {
        this.loadNotificationSerialized(slice.serialize());
    };
    FlowDeleted.prototype.loadMutationNotificationContractSerialized = function (slice) {
        this.class_ = Class_1.Class[slice.class];
        this.atAsString = slice.at;
        this.message = typeof slice.message !== 'undefined' ? slice.message : undefined;
        this.userID = new octopus_common_1.UserID(slice.userID);
        this.userName = typeof slice.userName !== 'undefined' ? slice.userName : undefined;
    };
    FlowDeleted.prototype.loadMutationNotificationContract = function (slice) {
        this.loadMutationNotificationContractSerialized(slice.serialize());
    };
    FlowDeleted.prototype.loadNotificationWithUserSerialized = function (slice) {
        this.class_ = Class_1.Class[slice.class];
        this.atAsString = slice.at;
        this.message = typeof slice.message !== 'undefined' ? slice.message : undefined;
        this.userID = new octopus_common_1.UserID(slice.userID);
        this.userName = typeof slice.userName !== 'undefined' ? slice.userName : undefined;
    };
    FlowDeleted.prototype.loadNotificationWithUser = function (slice) {
        this.loadNotificationWithUserSerialized(slice.serialize());
    };
    FlowDeleted.prototype.serialize = function () {
        return {
            userID: this.userID.serialize(),
            userName: typeof this.userName !== 'undefined' ? this.userName : undefined,
            class: Class_1.Class[this.class_],
            at: this.atAsString,
            message: typeof this.message !== 'undefined' ? this.message : undefined,
            appID: this.appID,
            appName: typeof this.appName !== 'undefined' ? this.appName : undefined,
            flowID: this.flowID,
            flowName: this.flowName
        };
    };
    FlowDeleted.PackageName = 'net.playq.octopus.notifications';
    FlowDeleted.ClassName = 'FlowDeleted';
    FlowDeleted.FullClassName = 'net.playq.octopus.notifications.FlowDeleted';
    return FlowDeleted;
}());
exports.FlowDeleted = FlowDeleted;
NotificationWithFlow_1.NotificationWithFlowStruct.register(FlowDeleted.FullClassName, FlowDeleted);
NotificationWithApp_1.NotificationWithAppStruct.register(FlowDeleted.FullClassName, FlowDeleted);
Notification_1.NotificationStruct.register(FlowDeleted.FullClassName, FlowDeleted);
MutationNotificationContract_1.MutationNotificationContractStruct.register(FlowDeleted.FullClassName, FlowDeleted);
NotificationWithUser_1.NotificationWithUserStruct.register(FlowDeleted.FullClassName, FlowDeleted);
var irt_2 = require("@playq/irt");
irt_2.Introspector.register(FlowDeleted.FullClassName, {
    full: FlowDeleted.FullClassName,
    short: FlowDeleted.ClassName,
    package: FlowDeleted.PackageName,
    type: irt_2.IntrospectorTypes.Data,
    ctor: function () { return new FlowDeleted(); },
    fields: [
        {
            name: 'userID',
            accessName: 'userID',
            type: { intro: irt_2.IntrospectorTypes.Id, full: 'net.playq.octopus.common.UserID' }
        },
        {
            name: 'userName',
            accessName: 'userName',
            type: { intro: irt_2.IntrospectorTypes.Opt, value: { intro: irt_2.IntrospectorTypes.Str } }
        },
        {
            name: 'class',
            accessName: 'class_',
            type: { intro: irt_2.IntrospectorTypes.Enum, full: 'net.playq.octopus.notifications.Class' }
        },
        {
            name: 'at',
            accessName: 'at',
            type: { intro: irt_2.IntrospectorTypes.Tsz }
        },
        {
            name: 'message',
            accessName: 'message',
            type: { intro: irt_2.IntrospectorTypes.Opt, value: { intro: irt_2.IntrospectorTypes.Str } }
        },
        {
            name: 'appID',
            accessName: 'appID',
            type: { intro: irt_2.IntrospectorTypes.I64 }
        },
        {
            name: 'appName',
            accessName: 'appName',
            type: { intro: irt_2.IntrospectorTypes.Opt, value: { intro: irt_2.IntrospectorTypes.Str } }
        },
        {
            name: 'flowID',
            accessName: 'flowID',
            type: { intro: irt_2.IntrospectorTypes.I64 }
        },
        {
            name: 'flowName',
            accessName: 'flowName',
            type: { intro: irt_2.IntrospectorTypes.Str }
        }
    ]
});
//# sourceMappingURL=FlowDeleted.js.map